/**
 * The resolution tier's one entry point — fold a recorded step list rules-free.
 *
 * A leaf-handler group of `./leafReducer`'s switch; see `../reducer` for the tier's contract.
 */

import { ok } from "@lancer-vtt/shared";
import { applyResolvedLanded } from "../applyResolved";
import { invertSteps, type ResolvedStep } from "../steps";
import { changed, type EncounterHandler } from "./context";

export const applyApplyResolved: EncounterHandler<"apply_resolved"> = (state, cmd) => {
  // The resolved step list is applied **rules-free**: the reducer never re-rolls or
  // re-decides — `resolve` (in `@lancer-vtt/rules`)
  // already drew the dice and recorded every outcome. We just fold the recorded
  // grounded deltas. The inverse is `apply_resolved` carrying the inverted step
  // list (grounded deltas reversed, record-only steps dropped), so a resolution
  // undoes/redoes exactly like any other command. It inverts the deltas as they landed,
  // so a clamped one undoes only what it changed (`applyResolvedLanded`).
  const steps: ResolvedStep[] = cmd.steps;
  const { state: next, landed } = applyResolvedLanded(state, steps);
  return ok({
    state: next,
    inverse: {
      type: "apply_resolved",
      actorId: cmd.actorId,
      steps: invertSteps(landed),
      kind: cmd.kind,
    },
    events: changed(null),
  });
};
